import { RoutesComp } from "./routes/Routes";

function App() {
  return (
    <div className="App">
      <RoutesComp />
    </div>
  );
}

export default App;
